import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import ServiceArea from "./sections/ServiceArea";
import Accreditations from "./sections/Accreditations";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Contact />
      <ServiceArea />
      <Accreditations />
      <Footer />
    </div>;
}